import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { UserPermissions } from "lib/services";
import _ from "lodash";
import { deprecate } from "util";

export class ItemTaxonomyId extends TaxonomyIdItem {
  static TYPE_PREFIX: string = "atn";

  /**
   * Will create a TaxonomyId object by parsing a string. Can throw an Error is the string is invalid
   * @param taxonomyId The taxonomyId string to parse
   * @returns The TaxonomyId object
   */
  public static Parse(taxonomyId: string): ItemTaxonomyId {
    const itemTaxonomyId = new ItemTaxonomyId(taxonomyId);
    return itemTaxonomyId;
  }

  public static ParseWithoutTypePrefix(taxonomyId: string): ItemTaxonomyId {
    try {
      if (taxonomyId.indexOf(ItemTaxonomyId.TYPE_PREFIX) === 0) {
        return new ItemTaxonomyId(taxonomyId);
      } else {
        return this.Parse(`${ItemTaxonomyId.TYPE_PREFIX}::${taxonomyId}`);
      }
    } catch (error) {
      throw new Error(`Invalid taxonomyId: ${taxonomyId}`);
    }
  }

  /**
   * Builds a string representation
   * @returns The TaxonomyId string that represents this object
   * @deprecated Use toString() instead
   */
  public getTaxonomyId(): string {
    return this.toString();
  }

  /**
   * Builds a string representation without the type prefix. Useful to use in URL and API calls
   * @returns The URL safe string
   */
  public getUrlSuffix(): string {
    return `${this.dataDomain}/${this.itemLevelsString}/${this.itemName}`;
  }
}

export function normalizeSoftwareTaxonomyId(taxonomyId: string): string {
  if (!UserPermissions.current.hasPermission("catalogical")) {
    // TODO remove this replace, to fully use itsoftware for ordering
    return taxonomyId.replace("itsoftware", "software");
  }
  return taxonomyId;
}
